module.exports = __webpack_public_path__ + "static/media/M43ws.4fdfdd59.pdf";